module.exports = __webpack_public_path__ + "img/wrong.4de701ed.svg";